<main class="mat-body">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h4 class="mat-h4 text-center">{{ 'error.unauthorized'|translate }}</h4>
            </div>
        </div>
    </div>
</main>
